"use client";

import { 
  ChakraProvider as LibraryChakraProvider, 
  ColorModeScript 
} from "@chakra-ui/react";
import { theme } from "@utils/theme";

export function ChakraProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      {/* Force light mode */}
      <ColorModeScript initialColorMode="light" />
      <LibraryChakraProvider theme={theme} resetCSS={true}>{children}</LibraryChakraProvider>
    </>
  );
}
